import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import store from '../../Store';
import ValuesList from './ComponentList';
import ValueActions from './ComponentActions';
import { getValues } from './Actions';
import reducerRegistry from '../../ReducerRegistry';
import reducer from './Reducer';
reducerRegistry.register('values', reducer);
const ValuesActionElement = document.getElementById('values-actions');
if (ValuesActionElement) {
    store.dispatch(getValues());
    render(_jsx(Provider, Object.assign({ store: store }, { children: _jsx(ValueActions, {}) })), ValuesActionElement);
    render(_jsx(Provider, Object.assign({ store: store }, { children: _jsx(ValuesList, {}) })), document.getElementById('values-list'));
}
